export default __webpack_public_path__ + "static/media/key.a581ba62.svg";